
export enum UserRole {
  ORG_ADMIN = 'ORG_ADMIN',
  LOCATION_MANAGER = 'LOCATION_MANAGER',
  DEPT_MANAGER = 'DEPT_MANAGER',
  TEAM_LEAD = 'TEAM_LEAD',
  STAFF = 'STAFF',
  FINANCE = 'FINANCE'
}

export enum DepartmentType {
  FAMILY_YOUTH = 'Family & Youthwork',
  HEALTH_WELLBEING = 'Health & Wellbeing',
  HOUSING = 'Housing',
  TRAINING_EDUCATION = 'Training & Education',
  SUPPORT_ADVICE = 'Support & Advice'
}

export interface OpeningHours {
  open: string;
  close: string;
  isClosed: boolean;
}

export interface Location {
  id: string;
  name: string;
  address: string;
  departments: DepartmentType[];
  type: 'Housing' | 'YP Services' | 'Community' | 'Other';
  openingHours?: Record<string, OpeningHours>; // Day of week -> Hours
  status?: 'In Service' | 'Not In Service';
}

export interface Skill {
  id: string;
  name: string;
  expiryDate?: string;
  isMandatory: boolean;
}

export interface Staff {
  id: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  primaryLocationId: string;
  assignedLocationIds: string[]; // Multi-site support
  departments: DepartmentType[];
  skills: Skill[];
  contractType: 'Full-time' | 'Part-time' | 'Zero-hours' | 'Volunteer';
  maxWeeklyHours: number;
  availability: Record<string, string[]>; // Day of week -> Array of available slots
  complianceStatus: 'Active' | 'Warning' | 'Critical';
}

export interface Shift {
  id: string;
  staffId: string | null; // null means unassigned
  locationId: string;
  department: DepartmentType;
  startTime: string;
  endTime: string;
  roleName: string;
  requiredSkills: string[];
  status: 'Published' | 'Draft' | 'Swap-Requested';
}

export interface AppState {
  currentLocation: string;
  currentDepartment: DepartmentType;
  selectedDate: Date;
  view: 'overview' | 'rota' | 'people' | 'leave' | 'timesheets' | 'jobs' | 'forms' | 'reports' | 'settings' | 'files' | 'warmSpaces' | 'locations';
}
